import './Header.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useBoundAction } from 'src/hooks/useBoundAction';
import { Modal } from 'src/modules/common/components/Modal';
import { UserLanguage } from 'src/modules/common/components/UserLanguage';
import { FEEDBACK_OPEN } from 'src/modules/feedback/actions/FeedbackActions';
import { getFeedbackModal } from 'src/modules/feedback/selectors/getFeedbackModal';
import { FeedbackModal } from 'src/modules/feedback/views/FeedbackModal';

export const Header = (): React.ReactElement => {
  const feedbackModalOpened = useSelector(getFeedbackModal);

  const handleClose = useBoundAction(FEEDBACK_OPEN.trigger, false);
  return (
    <div
      className="bp-header"
    >
      <Link to="/" className="bp-header__branding">
        <img
          alt="Logo"
          src="/images/logo.svg"
          className="bp-header__logo"
        />
      </Link>

      <div className="bp-header__controls">
        <UserLanguage/>

        <Modal
          className="bp-feedback-modal"
          opened={feedbackModalOpened}
          handleClose={handleClose}
          size="md"
        >
          <FeedbackModal onClose={handleClose}/>
        </Modal>
      </div>
    </div>
  );
};
